module.exports = __webpack_public_path__ + "img/blueLabel_tobala.f6e9f706.jpg";